import RecentOrders from './RecentOrders.component';

export default RecentOrders;
